import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  difference, map, filter, pick,
} from 'lodash';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { Modal, Button, FormGroup, FormControl, ControlLabel, HelpBlock, Tab, Tabs } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import NumberFormat from 'react-number-format';
import { getUser } from '../../../Auth/AuthReducer';
import { getAllProducts } from '../../../Setup/SetupReducer';

import { validateAccount, updateAccount, editAccount,
  editAccountSelectContacts, editAccountEditContact,
} from '../../CEActions';
import { getEditingAccount } from '../../CEReducer';

import ContactList from '../contact-list';
import WindowResizeListener from '../../../../components/window-size-listener';

import ProductTable from './tv-produtc-table';

class CEEditModal extends Component {
  constructor() {
    super();
    this.state = {
      tab: 1,
      contactContainerWidth: 0,
    };

    this.onWindowResize = this.onWindowResize.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelectContacts = this.handleSelectContacts.bind(this);
    this.handleEditContact = this.handleEditContact.bind(this);
    this.renderField = this.renderField.bind(this);
    this.renderNumericField = this.renderNumericField.bind(this);
    this.onSelectProducts = this.onSelectProducts.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { isOpen } = this.props;
    if (!isOpen && nextProps.isOpen) {
      const { account } = nextProps;
      const values = { ...account.account };
      if (values.website) {
        let website = values.website.toLowerCase();
        if (website.indexOf('http://') < 0 && website.indexOf('https://') < 0) {
          website = `http://${website}`;
        }
        values.website = website;
      }
      this.props.initialize({
        name: values.name,
        website: values.website,
        annual_revenue: values.annual_revenue,
        number_of_employees: values.number_of_employees,
        industry: values.industry,
        phone: values.phone,
        owner_id: values.owner_id,
        account_id: values.account_id,
        amount: account.amount,
        additional_information: account.additional_information || '',
        question: account.question || '',
        selected_product_id: account.selected_product_id,
        selected_product_ids: account.selected_product_ids || [],
      });
      this.setState({ tab: nextProps.tab });
    }
  }

  onWindowResize() {
    if (this.contactContainer) {
      this.setState({ contactContainerWidth: this.contactContainer.offsetWidth });
    }
  }

  handleTabSelect(tab) {
    this.setState({ tab });
  }
  contactTabOnSelect() {
    this.onWindowResize();
  }

  close() {
    const { account } = this.props;
    if (account) {
      this.props.dispatch(editAccount(account));
    }
  }

  onSelectProducts(products) {
    this.props.change('selected_product_ids', map(products, 'id'));
  }

  handleSubmit(data) {
    const { valid, account } = this.props;
    if (valid) {
      const params = {
        ...account,
        ...(pick(data, ['name', 'amount', 'additional_information', 'question', 'selected_product_id', 'selected_product_ids'])),
        account: pick(data, ['name', 'website', 'annual_revenue', 'number_of_employees', 'industry', 'phone', 'owner_id', 'account_id']),
      };
      this.props.dispatch(updateAccount(params))
        .then(
          (newParams) => {
            this.props.onUpdateAccount(newParams);
            this.close();
          }
        );
    }
  }
  handleSelectContacts(contacts) {
    this.props.dispatch(editAccountSelectContacts(contacts));
  }
  handleEditContact(contact) {
    this.props.dispatch(editAccountEditContact(contact));
  }
  renderField({
    input, label, type, placeholder, className, componentClass, hint, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState} className={className}>
        <ControlLabel>{label}</ControlLabel>
        <FormControl
          {...input}
          componentClass={componentClass}
          placeholder={placeholder}
          type={type}
          disabled={submitting}
        />
        <FormControl.Feedback />
        {hint !== undefined && <HelpBlock>{hint}</HelpBlock>}
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }
  renderNumericField({
    input, label, prefix, placeholder, className, thousandSeparator, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState} className={className}>
        <ControlLabel>{label}</ControlLabel>
        <NumberFormat
          value={input.value}
          thousandSeparator={thousandSeparator}
          className="form-control"
          prefix={prefix}
          disabled={submitting}
          placeholder={placeholder}
          onValueChange={(values, e) => {
            this.props.change(input.name, parseFloat(values.value));
            this.props.touch(input.name);
          }}
        />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }
  renderAccountTab() {
    return (
      <div>
        <Field
          name="name"
          type="text"
          component={this.renderField}
          label="Account Name"
          placeholder="account name"
        />
        <div className="row">
          <Field
            name="annual_revenue"
            type="text"
            component={this.renderNumericField}
            label="Annual Revenue"
            thousandSeparator
            className="col-sm-6"
            prefix="$"
            placeholder="account annual revenue"
          />
          <Field
            name="number_of_employees"
            type="text"
            component={this.renderNumericField}
            label="Number of Employees"
            className="col-sm-6"
            thousandSeparator
            placeholder="number of account's employees"
          />
        </div>
        <div className="row">
          <Field
            name="industry"
            className="col-sm-6"
            type="text"
            component={this.renderField}
            label="Industry"
            placeholder="account's field of industry"
          />
          <Field
            name="phone"
            className="col-sm-6"
            type="text"
            component={this.renderField}
            label="Phone"
            placeholder="account's phone number"
          />
        </div>
        <Field
          name="website"
          type="text"
          component={this.renderField}
          label="Website"
          placeholder="account's website"
        />
      </div>
    );
  }

  renderAdditionalInfoTab() {
    return (
      <div>
        <Field
          name="question"
          componentClass="textarea"
          component={this.renderField}
          label="Questions"
          placeholder="Add additional questions you would like TruVoice by Corporate Visions to ask the buyers for this account."
        />
        <Field
          name="additional_information"
          componentClass="textarea"
          component={this.renderField}
          label="Additional Information"
          placeholder="Add additional information you would like TruVoice by Corporate Visions to know about this account or the contact we will be speaking to."
        />
      </div>
    );
  }

  render() {
    const {
      account, isOpen, handleSubmit, submitFailed, submitting,
      selectedProductIds,
    } = this.props;
    const hasAccount = account !== null && account !== undefined;
    const tracking = hasAccount ? account.tracking : null;
    const selectedContactIds = hasAccount ? map(account.selected_contacts, 'contact_id') : [];
    const submittedContactIds = tracking ? tracking.submittedContactIds : [];
    const avaiableContactIds = difference(selectedContactIds, submittedContactIds);

    let contactTab = 'Contacts';
    if (selectedContactIds.length === 0) {
      contactTab = (
        <span>
          Contacts <Fa name="exclamation-triangle" className="text-danger" />
        </span>
      );
    } else {
      contactTab = (
        <span>
          Contacts <span className="badge">{selectedContactIds.length}</span>
        </span>
      );
    }

    let productTab = 'Products';
    if (selectedProductIds.length === 0) {
      productTab = (
        <span>
          Products <Fa name="exclamation-triangle" className="text-danger" />
        </span>
      );
    } else {
      productTab = (
        <span>
          Products <span className="badge">{selectedProductIds.length}</span>
        </span>
      );
    }



    return (
      <Modal show={isOpen} backdrop="static" keyboard={false} onHide={this.close} bsSize="lg">
        {hasAccount && <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>Account &amp; Contact Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="well well-sm">
              Update account information prior to submitting this account to TruVoice.
              Make sure at least one contact has been selected in the <strong>Contacts</strong> tab 
              and at least one product has been selected in the <strong>Product</strong> tab.
            </div>
            {submitFailed && <div className="alert alert-danger">
              Please check all the required fields.
            </div>}
            <div ref={(el) => { this.contactContainer = el; }}>
              <p />
              <WindowResizeListener onResize={this.onWindowResize} />
            </div>
            <Tabs activeKey={this.state.tab} onSelect={this.handleTabSelect} id="account-edit-tabs">
              <Tab eventKey={1} title="Account">
                <p />
                {this.renderAccountTab()}
              </Tab>
              <Tab
                eventKey={2}
                title={contactTab}
                onSelect={this.contactTabOnSelect}
              >
                <p />
                <ContactList
                  key={account.account_id}
                  account={account}
                  selectedContacts={account.selected_contacts}
                  opportunityContacts={filter(account.contacts, { isOpportunityContact: true })}
                  width={this.state.contactContainerWidth}
                  submittedContactIds={submittedContactIds || []}
                  onSelectContacts={this.handleSelectContacts}
                  disabledWhenSubmitted={false}
                  onEditContact={this.handleEditContact}
                  isActive={(isOpen && this.state.tab === 2)}
                  editingContact={account.editingContact}
                />
              </Tab>
              <Tab
                eventKey={3}
                title={productTab}
                onSelect={this.contactTabOnSelect}
              >
                <p />
                <ProductTable
                  disabled={submitting}
                  products={this.props.products}
                  width={this.state.contactContainerWidth}
                  selectedProductIds={this.props.selectedProductIds}
                  onSelectProducts={this.onSelectProducts}
                  isActive={(isOpen && this.state.tab === 3)}
                />
              </Tab>
              <Tab eventKey={4} title="Other">
                <p />
                {this.renderAdditionalInfoTab()}
              </Tab>
            </Tabs>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-sm-6 col-sm-push-6">
                <div className="pull-right">
                  <Button bsStyle="link" onClick={this.close}>Cancel</Button>
                  <Button bsStyle="primary" type="submit">
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </form>}
      </Modal>
    );
  }
}

CEEditModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  account: PropTypes.shape({}),
  submitting: PropTypes.bool.isRequired,
  submitFailed: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  tab: PropTypes.number,
  touch: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  loginUser: PropTypes.shape({}).isRequired,
  selectedProductId: PropTypes.string,
  selectedProductIds: PropTypes.arrayOf(PropTypes.string),
  allProducts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tvProductMappings: PropTypes.shape({}),
  onUpdateAccount: PropTypes.func,

};
CEEditModal.defaultProps = {
  tab: 1,
  account: {},
  selectedProductId: null,
  onUpdateAccount: () => {},
  selectedProductIds: [],
  tvProductMappings: {},
};

const selector = formValueSelector('ceEditingAccountForm'); // <-- same as form name

function mapStateToProps(state) {
  const editingAccount = getEditingAccount(state);
  return {
    account: editingAccount,
    loginUser: getUser(state),
    allProducts: getAllProducts(state),
    selectedProductId: selector(state, 'selected_product_id'),
    selectedProductIds: selector(state, 'selected_product_ids'),
    isOpen: editingAccount !== undefined && editingAccount !== null,
  };
}

const validate = account => validateAccount(account);

const CEEditModalForm = reduxForm({
  form: 'ceEditingAccountForm',
  validate,
})(CEEditModal);

export default connect(mapStateToProps)(CEEditModalForm);
